






































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Customer } from '@/models/DTO/customer/customer.model';
import { routeName } from '@/constants/route.constants';
import { BaseAPIErrorModel } from '@/models/DTO/base-api-error.model';
import { mapState } from 'vuex';
import CustomerModule, {
  CUSTOMERS_MODULE_NAME
} from '@/store/modules/customer.module';
import RegisteredTagModule, {
  REGISTERED_TAG_MODULE_NAME
} from '@/store/modules/registered-tag.module';
import AuthenticationModule, {
  AUTHENTICATION_MODULE_NAME
} from '@/store/modules/authentication.module';
import store from '@/store';
import { getModule } from 'vuex-module-decorators';
import { RegisteredTag } from '@/models/DTO/registered-tag/registered-tag.model';
import { PaymentsService } from '@/services/payments.service';
import { container, cid } from 'inversify-props';
import { PaymentRequest as PayaRequest } from '@/models/DTO/payments/payment-request.model';
import DisplayOwnerDetailsComponent from '@/components/public/display-owner-details.component.vue';
import { VerifyPaymentRequestModel } from '@/models/DTO/payments/verify-payment-request.model';
import { VerifyPaymentResponse } from '@/models/DTO/payments/verify-payment-response.model';
import PayPalComponent from './paypal.component.vue';
import { UNKNOWN_VETERINARIAN_ID } from '@/constants/anonymous-registration.constants';
import LoadingComponent from '@/components/shared/loading.component.vue';

const customerModule: CustomerModule = getModule(CustomerModule, store);

const registeredTagModule: RegisteredTagModule = getModule(
  RegisteredTagModule,
  store
);

const authenticationModule: AuthenticationModule = getModule(
  AuthenticationModule,
  store
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const PayJS: any;

@Component({
  components: {
    DisplayOwnerDetailsComponent,
    'paypal-component': PayPalComponent,
    LoadingComponent
  },
  computed: {
    ...mapState(REGISTERED_TAG_MODULE_NAME, {
      currentRegisteredTag: 'currentRegisteredTag',
      showLoading: 'showLoading',
      errorTagResponse: 'errorResponse'
    }),
    ...mapState(CUSTOMERS_MODULE_NAME, [
      'currentCustomer',
      'showButtonLoading',
      'errorResponse'
    ]),
    ...mapState(AUTHENTICATION_MODULE_NAME, {
      showAuthLoading: 'showLoading'
    })
  }
})
export default class PayaFormComponent extends Vue {
  @Prop({
    required: true
  })
  public code: string;

  @Prop({
    required: true
  })
  public customer: Customer;

  public currentRegisteredTag: RegisteredTag | null;
  public currentCustomer: Customer | null;
  public showLoading: boolean;
  public showButtonLoading: boolean;
  public showAuthLoading: boolean;
  public errorResponse: BaseAPIErrorModel | null;
  public errorTagResponse: BaseAPIErrorModel | null;
  public cost = '2.99';

  public get routeName(): typeof routeName {
    return routeName;
  }

  @Watch('errorResponse', { deep: true })
  private onErrorResponseChanged(value: BaseAPIErrorModel) {
    if (value) {
      const errors = value.getAllErrorMessages();
      return this.$toasted.error(errors.join());
    }
  }

  @Watch('errorTagResponse', { deep: true })
  private onErrorTagResponseChanged(value: BaseAPIErrorModel) {
    if (value) {
      const errors = value.getAllErrorMessages();
      return this.$toasted.error(errors.join());
    }
  }

  public async created() {
    const paymentsService: PaymentsService = container.get<PaymentsService>(
      cid.PaymentsService
    );

    const paymentRequest: PayaRequest = await paymentsService.createPaymentRequestObject(
      {
        orderNumber: this.code
      }
    );

    this.initializePayJS(paymentRequest);
  }

  public initializePayJS(request: PayaRequest) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    PayJS(['PayJS/UI'], (UI: any) => {
      UI.Initialize({
        clientId: request.clientId,
        merchantId: request.merchantId,
        requestType: request.requestType,
        orderNumber: this.code,
        amount: request.amount,
        authKey: request.authKey,
        salt: request.salt,
        elementId: 'submitPayment',
        postbackUrl: request.postbackUrl,
        environment: request.environment
      });
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      UI.setCallback((resp: any) => {
        const paymentRequest: VerifyPaymentRequestModel = resp.getResponseHash();

        this.verifyPaymentRequest(paymentRequest).then(
          (verified: VerifyPaymentResponse) => {
            if (verified.success) {
              const success: boolean = resp.getTransactionSuccess();

              if (success) {
                this.onConfirmationOfPayment();
              }
            } else {
              this.$toasted.error(
                verified.errorMessage ||
                  'Oops... Something Went Wrong. Please try again.'
              );
            }
          }
        );
      });
    });
  }

  public async verifyPaymentRequest(
    paymentRequest: VerifyPaymentRequestModel
  ): Promise<VerifyPaymentResponse> {
    const paymentsService: PaymentsService = container.get<PaymentsService>(
      cid.PaymentsService
    );

    const paymentResponse: VerifyPaymentResponse = await paymentsService.verifyPaymentResponse(
      {
        ...paymentRequest
      }
    );

    return paymentResponse;
  }

  public async onConfirmationOfPayment(): Promise<void> {
    // Create customer first and then register the tag
    await authenticationModule.acceptTermsAction(true);
    await customerModule.registerCustomerIfNeededAction({ ...this.customer });

    if (!this.errorResponse && this.currentCustomer) {
      await registeredTagModule.addNewTagAction({
        code: this.code,
        customerId: this.currentCustomer.id,
        veterinarianOfficeId: UNKNOWN_VETERINARIAN_ID
      });

      if (!this.errorTagResponse && this.currentRegisteredTag) {
        await registeredTagModule.orderDetailsAction({
          cost: this.cost,
          tag: this.code,
          orderDate: new Date()
        });

        this.$router.replace({ name: routeName.public.paymentConfirmation });
      }
    }
  }

  public onEditClick() {
    this.$router.replace({
      name: routeName.public.register,
      params: {
        tagCode: this.code
      }
    });
  }
}
